export default __webpack_public_path__ + "static/media/greenTech.96ee8249.jpg";